import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import { useState } from "react";
import BrandLogo from "@/components/BrandLogo";

const links = [
  { to: "/", label: "Beranda" },
  { to: "/booking", label: "Booking" },
  { to: "/events", label: "Event & Turnamen" },
];

export default function Navbar() {
  const loc = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <header
      data-testid="main-navbar"
      className="fixed top-0 left-0 right-0 z-50 bg-black/70 backdrop-blur-xl border-b border-white/10"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo">
          <BrandLogo size="md" subtitle="Zone" />
        </Link>

        <nav className="hidden md:flex items-center gap-1">
          {links.map((l) => {
            const active = loc.pathname === l.to;
            return (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-link-${l.to.replace("/", "") || "home"}`}
                className={`relative px-5 py-2 text-sm font-semibold uppercase tracking-wider transition-colors duration-200 ${
                  active ? "text-[#00E5FF]" : "text-gray-300 hover:text-white"
                }`}
              >
                {l.label}
                {active && (
                  <span className="absolute bottom-0 left-1/2 -translate-x-1/2 w-6 h-[2px] bg-[#00E5FF]" />
                )}
              </Link>
            );
          })}
          <Link
            to="/admin/login"
            data-testid="nav-admin-btn"
            className="ml-4 px-5 py-2 text-sm font-bold uppercase tracking-wider border border-white/20 hover:border-[#00E5FF] hover:text-[#00E5FF] transition-colors duration-200"
          >
            Admin
          </Link>
        </nav>

        <button
          className="md:hidden text-white"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden bg-black/95 border-t border-white/10">
          <div className="px-6 py-4 flex flex-col gap-2">
            {links.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                onClick={() => setOpen(false)}
                data-testid={`nav-mobile-link-${l.to.replace("/", "") || "home"}`}
                className="py-3 text-sm font-semibold uppercase tracking-wider text-gray-300 border-b border-white/5"
              >
                {l.label}
              </Link>
            ))}
            <Link
              to="/admin/login"
              onClick={() => setOpen(false)}
              className="py-3 text-sm font-bold uppercase tracking-wider text-[#00E5FF]"
              data-testid="nav-mobile-admin"
            >
              Admin Login →
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
